import { ReactNode } from 'react';
import classes from './SettingsListItem.module.css';

type SettingsListItemProps = {
  initial: string;
  title: string;
  subtitle?: string;
  action?: ReactNode;
};

/** A tinted row with an initial, a title and an optional action, e.g. a leader or a channel. */
export const SettingsListItem = ({ initial, title, subtitle, action }: SettingsListItemProps) => (
  <li className={classes.item}>
    <span aria-hidden="true" className={classes.initial}>
      {initial}
    </span>
    <span className={classes.text}>
      <span className={classes.title}>{title}</span>
      {subtitle && <span className={classes.subtitle}>{subtitle}</span>}
    </span>
    {action}
  </li>
);
